/** Public wordmark lockup (icon + product logotype) for the site header and email. */
export const BRAND_WORDMARK_PATH = '/wordmarkDark.svg';

/** Raster wordmark for email and other non-SVG contexts. */
export const BRAND_WORDMARK_PNG_PATH = '/wordmarkDark.png';

/** Default social share / OG cover (1200×630). */
export const SITE_COVER_PATH = '/og-cover.jpg';

/** Default OG cover dimensions (Facebook recommends explicit width/height). */
export const SITE_COVER_WIDTH = 1200;
export const SITE_COVER_HEIGHT = 630;

/**
 * Forest cover behind page heroes (landing, membership, hosting, support).
 * WebP of `profile-default-cover.png` (41 KB vs 122 KB). The PNG stays for
 * profile defaults and the mobile app, which load it by URL.
 * `public/index.html` preloads this path on hero routes; keep them in sync.
 */
export const HERO_COVER_PATH = '/profile-default-cover.webp';
export const HERO_COVER_WIDTH = 1024;
export const HERO_COVER_HEIGHT = 682;
